import { toast } from "sonner";

/** Enregistrement du service worker + stratégie de mise à jour : nouvelle version détectée → toast « Recharger » → SKIP_WAITING → rechargement unique. */
export function registerSW() {
  if (!("serviceWorker" in navigator)) return;
  let reloading = false;
  navigator.serviceWorker.addEventListener("controllerchange", () => { if (reloading) return; reloading = true; window.location.reload(); });
  navigator.serviceWorker.addEventListener("message", (e) => {
    if (e.data?.type === "NAVIGATE" && e.data.url) {
      const u = new URL(e.data.url, window.location.origin);
      window.dispatchEvent(new CustomEvent("respondia:navigate", { detail: u.pathname + u.search + u.hash }));
    }
    if (e.data?.type === "PUSH_RECEIVED") {
      window.dispatchEvent(new Event("notifications-changed"));
      if (document.visibilityState === "visible" && e.data.title) toast(e.data.title, { description: e.data.body, action: e.data.link ? { label: "Ouvrir", onClick: () => window.dispatchEvent(new CustomEvent("respondia:navigate", { detail: e.data.link })) } : undefined });
    }
  });
  navigator.serviceWorker.register("/sw.js", { updateViaCache: "none" }).then((reg) => {
    const promptUpdate = (w) => { toast("Nouvelle version de Respondia disponible", { duration: 15000, action: { label: "Recharger", onClick: () => w.postMessage({ type: "SKIP_WAITING" }) } }); };
    if (reg.waiting && navigator.serviceWorker.controller) promptUpdate(reg.waiting);
    reg.addEventListener("updatefound", () => { const w = reg.installing; w?.addEventListener("statechange", () => { if (w.state === "installed" && navigator.serviceWorker.controller) promptUpdate(w); }); });
    const check = () => reg.update().catch(() => null);
    document.addEventListener("visibilitychange", () => { if (document.visibilityState === "visible") check(); });
    setInterval(check, 60 * 60 * 1000);
  }).catch(() => null);
}

export const isStandalone = () => window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;
export const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

/** Badge d'application (icône écran d'accueil) : synchronisé avec le compteur non lu de Respondia. */
export function setAppBadge(n) {
  if (!("setAppBadge" in navigator)) return;
  (n > 0 ? navigator.setAppBadge(n) : navigator.clearAppBadge()).catch(() => null);
}

const SPACE_ALIAS = { app: "employer", salarie: "employee", employer: "employer", employee: "employee" };
/** Dernier espace utilisé (employer | employee) : sert uniquement à ouvrir le bon écran au lancement de la PWA ; le rôle serveur reste la source de vérité. */
export function rememberSpace(space) { try { localStorage.setItem("respondia_space", SPACE_ALIAS[space] || space); } catch { /* privé */ } }
export function lastSpace() { try { return SPACE_ALIAS[localStorage.getItem("respondia_space")] || null; } catch { return null; } }
export function spaceForPath(path) { return path.startsWith("/salarie") ? "employee" : (path.startsWith("/app") || path === "/login" || path === "/register") ? "employer" : null; }
